import type { NearbyHeroData } from '@/modules/game-domain/world.types';
import type { NearbyHeroPresentation } from '@/modules/game-domain/render-snapshot';
import { HeroAnimationController } from './hero-animation';

/** Owns only presentation epochs. Shared-world transport reports position, never combat outcomes. */
export class NearbyHeroAnimations {
  private actors = new Map<number, { variant: number; controller: HeroAnimationController }>();
  constructor(private random: () => number = Math.random) {}
  retain(ids: ReadonlySet<number>): void {
    for (const id of this.actors.keys()) if (!ids.has(id)) this.actors.delete(id);
  }
  sample(heroes: readonly NearbyHeroData[], nowMs: number): NearbyHeroPresentation[] {
    this.retain(new Set(heroes.map(hero => hero.id)));
    return heroes.map(hero => {
      let actor = this.actors.get(hero.id);
      if (!actor || actor.variant !== hero.modelVariant) {
        actor = { variant: hero.modelVariant, controller: new HeroAnimationController(this.random) };
        this.actors.set(hero.id, actor);
      }
      return { ...hero, motion: actor.controller.sample(nowMs, hero.positionX, hero.positionY, null,
        false, hero.modelVariant, hero.isMoving !== true) };
    });
  }
  reset(): void { this.actors.clear(); }
}
